module.exports = __webpack_public_path__ + "static/media/icon-refresh-submain.f0cf27df.svg";